import { WiperWashIcon } from './WiperWashIcon';

/**
 * author: Michael Irigoyen
 * id CC8D7DD6-699C-4746-ACAB-84DCA7BBC5E9
 * name wiper-wash
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wiper-wash.svg
 * tags
 * - Automotive 
 */
export const WiperFluidIcon = WiperWashIcon;
export default WiperFluidIcon